// extracted by mini-css-extract-plugin
export default {"base":"ModalPopup_base__M3cbW","card":"ModalPopup_card__NxQ6v"};